import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SmartPreviewDirective} from './smart-preview.directive';
import {ZalamoTooltipModule} from '../zalamo-tooltip/zalamo-tooltip.module';
import {QuickPreviewService} from './quick-preview.service';
import {SessionsPreviewComponent} from './components/sessions-preview/sessions-preview.component';
import {ButtonModule} from '../button/button/button.module';


@NgModule({
            declarations:    [SmartPreviewDirective, SessionsPreviewComponent],
            imports:         [
              CommonModule, ZalamoTooltipModule, ButtonModule
            ],
            providers:       [QuickPreviewService],
            exports:         [SmartPreviewDirective]

          })
export class SmartPreviewModule {

  constructor(service: QuickPreviewService) {

    service.registerService('private_sessions', ((targetName, containerRef) => {
      console.log('SHOJW PRIVATE SESSIONS');
      return service.showPreview(targetName, SessionsPreviewComponent, containerRef);
    }));
  }
}

